module.exports = __webpack_public_path__ + "static/sakurayoga-8225d6111e43526a837c7525f35edfd8.png";